module.exports = __webpack_public_path__ + "img/icon_heart_12.b96fc7d0.svg";